import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Heading2,
    Stack,
} from '@myphx-engineering/phx-design-system';

export const CancelledNextSteps = ({
    prescriberPhone,
}: {
    prescriberPhone?: string | null;
}) => {
    const { t } = useTranslation();

    return (
        <Stack gap="sm">
            <Heading2>{t('orderConfirmation.subHeader')}</Heading2>
            <Body1>{t('prescription.cancelled.modal.body1')}</Body1>
            <Body1 bold>{t('prescription.cancelled.modal.body2')}</Body1>
            {prescriberPhone && (
                <Button
                    onClick={() => {
                        window.location.href = `tel:${prescriberPhone}`;
                    }}
                >
                    {t('prescription.cancelled.modal.callProvider')}
                </Button>
            )}
        </Stack>
    );
};
